import React from 'react';

import styled from '@emotion/styled'
import { keyframes } from '@emotion/core';
import Link from 'gatsby-link';

import { Grid, zIndexes, fontSize } from 'style';
import { ReactComponent as ArrowIcon } from 'assets/arrow.svg';

const LetsFightAverageComponent = () => (
    <Footer id="LetsFightAverage">
        <FooterWrapper>
            <Link to="/contact/">
                <FooterFixed>
                    <Grid.Container
                        data-cursor="lets-fight-average"
                        data-cursor-persistance="300">
                        <FooterText>
                            Let’s fight average
                            <ArrowIcon className="icon" />
                        </FooterText>
                    </Grid.Container>
                </FooterFixed>
            </Link>
        </FooterWrapper>
    </Footer>
);

const Footer = styled.div`
    width: 100%;
    height: 100vh;
    align-items: center;
    position: relative;
    bottom: 0;
    ${Grid.Container} {
        height: 100%;
        align-items: center;
        display: flex;
    }
`;
const FooterWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    clip: rect(0, auto, auto, 0);
    background-color: white;
    z-index: ${zIndexes.zLetsFight};
`;
const huerotator = keyframes`
	0% {
    filter: hue-rotate(0deg);
  }

  100% {
    filter: hue-rotate(360deg);
  }
`;

const FooterFixed = styled.div`
    width: 100%;
    height: 100%;
    align-items: center;
    position: fixed;
    bottom: 0;
    background: linear-gradient(
        45deg,
        rgba(252, 209, 209, 0.5) 0%,
        rgba(212, 230, 250, 0.5) 100%
    );
    animation: ${huerotator} 20s infinite alternate;
`;
const FooterText = styled.div`
    font-size: ${fontSize(40)};
    margin-left: 135px;
    .icon {
        vertical-align: middle;
        height: 28px;
        width: 22px;
        transform: rotate(-90deg);
        margin-left: 20px;
    }
`;

export default LetsFightAverageComponent;
